import React from 'react'

import { useNavigation } from '@react-navigation/native'
import { Button } from '@zet/design-system/button'
import { Icon } from '@zet/design-system/icons'
import { Stack, XStack } from '@zet/design-system/layout'
import { B2 } from '@zet/design-system/typography'

import { i18n } from '../../localization'
import useStore from '../../store'

const FloatingButton = () => {
  const navigation = useNavigation()
  const { setPartnerId } = useStore()
  return (
    <Stack className="relative">
      <Button
        className="absolute bottom-4 right-3 "
        style={{
          elevation: 10,
        }}
        size={'medium'}
        onPress={() => {
          setPartnerId(null)
          navigation.navigate('KnowYourCustomer', { source: 'sellButton' })
        }}
        eventName="click_action"
        eventPayload={{ item_name: 'home_page_start_selling' }}
      >
        <XStack className="items-center justify-center">
          <Icon type="RupeeCircleFilled" color="#fff" size={24} />
          <B2 style={{ color: 'white', marginLeft: 5 }}>
            {i18n.t('myLeads.sell')}
          </B2>
        </XStack>
      </Button>
    </Stack>
  )
}

export default React.memo(FloatingButton)
